// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomIconsLegend_root__2ihy5","text":"CustomIconsLegend_text__p6-5k"};